module.exports = "/lucky-balls/img/infobox/info_Box_032.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_032.png
// module id = 1097
// module chunks = 0